import { render, staticRenderFns } from "./rechargeAddOrEdit.vue?vue&type=template&id=20cd8a70&scoped=true&"
import script from "./rechargeAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./rechargeAddOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./rechargeAddOrEdit.vue?vue&type=style&index=0&id=20cd8a70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cd8a70",
  null
  
)

export default component.exports